





















































































































//import {db, functions, firestore} from "@/scripts/firebase";
import { NoticeProps,SentMessage,ReceivedMessage,UserPublicProfile } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
import { ValidationObserver,ValidationProvider  } from 'vee-validate'
import Notice from '@/components/Notice.vue';
import Common from '@/mixins/common'
import firebase from 'firebase';
import PanelSelectUser from '@/components/PanelSelectUser.vue';


interface MessageProps{
  [key: string]: {
    showBody?: boolean;
  };
}

@Component({
  components: {
    Notice,
    PanelSelectUser
  }
})

export default class Messanger extends Mixins(Common) {
  observers: (firebase.Unsubscribe | undefined)[] = []
  isPanelShow = false
  //userList: UserPublicProfile[] = []
  //messages: (ReceivedMessage | SentMessage)[] = []
  sentMessages: SentMessage[] = []
  receivedMessages: ReceivedMessage[] = []
  theMessage = {receivedMessageId: '',receiverUids: undefined as undefined | string[], receivers: [] as UserPublicProfile[], body: ''}
  //receiverUids: string[] = []
  //sentMessage = {} as SentMessage
  //receivedMessage = {} as ReceivedMessage
  messageProps: MessageProps = {}
  isLoading = false
  notice = {} as NoticeProps
  orderBy = 'creationTime'
  rMcolumns = [
    {
      field: 'sender',
    },
    {
      field: 'receivers',
    },
    {
      field: 'status',
    },
    {
      field: 'body',
    },
    {
      field: 'updateTime',
    },
    {
      field: 'creationTime',
    },
  ]

  $refs!: {
    receivers: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get receiverUids(){
    if(Array.isArray(this.theMessage.receiverUids)){
      this.$refs.receivers.validate()
    }
    return this.theMessage.receiverUids
  }

  get isDisabled() {
    return ! (this.theMessage.body !== '' && this.theMessage.receivers.length > 0)
  }

  async replyMessage(receivedMessage: ReceivedMessage){
    if(receivedMessage){
      const receiverPublicProfile =  await this.$getUserPublicProfileDocRef(receivedMessage.senderUid).get()
      const receiverPublicProfileData = receiverPublicProfile.data()
      if(receiverPublicProfileData){
        this.theMessage.receivedMessageId = receivedMessage.messageId || ''
        this.theMessage.receiverUids = [receivedMessage.senderUid]
        this.theMessage.receivers = [receiverPublicProfileData]
        const body = receivedMessage.body.split("\n").map((v) => {
          if(v === ''){
            return v
          }
          return '>' + v
        }).join("\n")
        this.theMessage.body = body
      }
    }
  }

  toggleBody(messageId: string){
    const f = this.messageProps[messageId].showBody ? false : true

    this.messageProps = {...this.messageProps, [messageId]: {showBody : f}}
  }

  toggleReceiver(user: UserPublicProfile){
    const theUid = user.uid || ''

    if(this.theMessage.receiverUids && this.theMessage.receiverUids.includes(theUid)){
      this.theMessage.receivers = this.theMessage.receivers.filter((user) => {
        if(user.uid === theUid){return false}
        return true
      })
    }else{
      this.theMessage.receivers.push(user)
    }

    this.theMessage.receiverUids = this.theMessage.receivers.map((user) => {return user.uid || ''})
  }

  onSelect(event: false | UserPublicProfile){
    if(event === false){
      this.isPanelShow = false
      return
    }
    this.toggleReceiver(event)
  }

  async created(){
    console.trace('created')

    //this.$store.commit("setLoading",true);
    //this.isLoading = true
    
    try{
      this.observers.push(this.$getUserSentMessageQuery().orderBy('creationTime','desc').onSnapshot((snapshot) => {
        this.sentMessages = snapshot.docs.map((doc) => {
          this.messageProps[doc.id] = {}
          const row = doc.data()
          return {messageId: doc.id,...row} as SentMessage
        })
      }))

      this.observers.push(this.$getUserReceivedMessageQuery().orderBy('creationTime','desc').onSnapshot((snapshot) => {
        this.receivedMessages = snapshot.docs.map((doc) => {
          const row = doc.data()
          this.messageProps[doc.id] = {}
          return {messageId: doc.id,...row} as ReceivedMessage
        })
      }))
    }catch(error){
      console.log(error)
    }finally{
   //   this.$store.commit("setLoading",false);
   //   this.isLoading = false
    }
  }

  async sendMessage(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true

        const receiverMeta: SentMessage['receiverMeta'] = {}
        const receiverUids: string[] = []
        
        this.theMessage.receivers.forEach((user) => {
          if(user.uid !== undefined){
            receiverUids.push(user.uid)
            receiverMeta[user.uid] = {
              displayName: user.displayName || '',
              lastName: user.lastName || '',
              firestName: user.firstName || '',
              lastNameYomigana: user.lastNameYomigana || '',
              firestNameYomigana: user.firstNameYomigana || '',
              ref: this.$getUserPublicProfileDocRef(user.uid)
            }
          }
        })

        const receivedMessageRef = (this.theMessage.receivedMessageId === '') ? undefined : this.$getReceivedMessageColRef().doc(this.theMessage.receivedMessageId)

        const data = {
          body: this.theMessage.body,
          schoolId: this.$store.getters.schoolId,
          senderUid: this.$store.getters.uid,
          senderAccessLevel: this.$store.getters.accessLevel,
          senderRole: this.$store.getters.role,
          senderRef: this.$getUserPublicProfileDocRef(),
          senderDisplayName: this.$store.getters.displayName,
          receiverMeta: receiverMeta,
          receiverUids: receiverUids,
          receivedMessageRef: receivedMessageRef,
          status: 'sending',
        }

        if(data.receivedMessageRef === undefined){
          delete data.receivedMessageRef
        }
      
        await this.$addDoc(this.$getSentMessageColRef(),data)

        this.notice = {
          message: this.$t('messenger.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('messenger.failure') as string
      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

/*
  sortUser(index: number){
    let orderBy = this.columns[index].field
    if(orderBy == 'role'){
      orderBy = 'accessLevel'
    }

    if(orderBy == 'firstName' || orderBy == 'lastName' ){
      orderBy += 'Yomigana'
    }

    if(this.orderBy == orderBy){
      this.columns[index].order = ! this.columns[index].order
    }else{
      this.orderBy = orderBy
    }

    this.groups.sort((a, b) => {
      const nameA = a[this.orderBy] || Number.MIN_SAFE_INTEGER
      const nameB = b[this.orderBy] || Number.MIN_SAFE_INTEGER

      if(nameA === nameB){
        return 0
      }else if(this.columns[index].order && nameA > nameB){
        return 1
      }else{
        return -1
      }
    });
  }
 */
  destroyed() {
    this.$unsubscriber(this.observers)
    console.trace('destroyed');
  }

}
